// Polyfills
import 'es6-promise/auto'
import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import App from './App'
import { ColorThemePlugin } from 'vuestic-ui/src/services/ColorThemePlugin'
import store from '../store'
// import router from '../router/index'
import router from '../router'
import moment from 'moment'
import AppLayout from '../components/admin/AppLayout'
import lazyLoading from '../router/lazyLoading'
import VuesticPlugin from 'vuestic-ui/src/components/vuestic-plugin'
import '../i18n/index'
import VueClipboard from 'vue-clipboard2'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import * as LocalStorageKeys from '@/local-storage/LocalStorageKeys'
// import VueSocketIO from '../components/tele/config'
import '../metrics'
import socketIo from 'socket.io-client'
import VueSocketIo from 'vue-socket.io'
import '../filters'
import '../utils/charts.js'
import interceptors from '../api/Interceptors'
import EventBus from '@/utils/EventBus'
import {FILTERS_CALENDAR_DAY, FILTERS_CALENDAR_VIEW} from "@/local-storage/LocalStorageKeys";
import SocketioService from "@/services/socketio.service";

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { faUpRightAndDownLeftFromCenter,
  faDownLeftAndUpRightToCenter,
  faCirclePlus,
  faCircleCheck,
} from '@fortawesome/free-solid-svg-icons'

import {
  faCircle
} from '@fortawesome/free-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add([faUpRightAndDownLeftFromCenter, faDownLeftAndUpRightToCenter, faCirclePlus, faCircleCheck, faCircle])

Vue.prototype.moment = moment

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

let url = ""
if (process.env.VUE_APP_ENVIRONMENT === 'local' || process.env.VUE_APP_ENVIRONMENT === 'demo' || process.env.VUE_APP_ENVIRONMENT === 'prod' || process.env.VUE_APP_ENVIRONMENT === 'production') {
  url = store.state.evocall_server
} else {
  url = store.state.evocall_server.replace("/evocall", "")
}
Vue.use(new VueSocketIo({
  debug: true,
  connection: socketIo(url, {
    autoConnect: false,
    secure: process.env.VUE_APP_ENVIRONMENT !== 'local',
    timeout: 500
  }),
  vuex: {
    store, actionPrefix: 'SOCKET_', mutationPrefix: 'SOCKET_'
  },
}))

Vue.use(VuesticPlugin)
Vue.use(VueClipboard)
Vue.use(ColorThemePlugin, {
  // Add or change theme colors here
  themes: {
    evollulight: '#34f5d4', evolludark: '#29C4AA', evollugraylight: '#6E6E6E', evollugraydark: '#414141',
  },
})

router.beforeEach((to, from, next) => {
  if (!store.state.hasLoaded) {
    if (to.redirectedFrom && to.redirectedFrom !== '/') {
      store.commit('SET_REDIRECT_FROM', to.redirectedFrom)
    }
  }
  store.commit('SET_LOADING', true)
  next()
})

let mediaHandler = () => {
  if (!window.matchMedia(`(min-width: 767px)`).matches) {
    store.dispatch('toggleSidebar', true)
  }
}

router.afterEach((to, from) => {
  mediaHandler()
  if (from.name !== null && store.state.loggedUser) {
    LocalStorageHelper.set(LocalStorageKeys.LAST_PAGE_ACCESSED, { email: store.state.loggedUser.email, uri: to.path })
  }
  store.commit('SET_LOADING', false)
})

Vue.router = router
Vue.use(VueAxios, axios)

Vue.use(VueAuth, {
  auth: {
    request: function (req, token) {
      this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token })
    }, response: function (res) {
      // Get Token from response body
      if (res.data.access_token) {
        // this.currentToken = res.data.access_token
        return res.data.access_token
      }
      var token = this.options.http._getHeaders.call(this, res).Authorization
      if (token) {
        token = token.split('Bearer ')
        return token[token.length > 1 ? 1 : 0]
      }
      if (res.token) {
        return res.token
      }

      if (res.request.responseURL === store.state.evollauth_server + '/v2/auth/me' && res.status === 403) {
        EventBus.$emit('user-without-permissions');
      }
    },
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: { url: store.state.evollauth_server + '/token', fetchUser: false },
  refreshData: { enabled: false },
  fetchData: { url: store.state.evollauth_server + '/v2/auth/me', method: 'GET', enabled: true },
  logoutData: { url: store.state.evollauth_server + '/auth/logout', method: 'POST', makeRequest: true },
  authRedirect: { name: 'login' },
  parseUserData: (data) => {

    if(!Object.keys(data).length) {
      return {}
    }

    const activeServices = [
      1, // Leads
      2, // Booking
      4, // Homelab
      6, // Auth
      7, // Reports
      8, // Evocall
      11, // Ranu
      15, // Auth-Clinical Evollu
      16, // Auth-Clinical Acustica
      17, // Optometry
      18, // Leads Web Service
      19, // Iframe
      20, // Statistics 2.0
      21, // Virtual Waiting Room
      22, // Check-up Plus
      23, // Wellbeing
      24, // Activities Agenda
      25 // People Manager
    ]

    if(data.password_valid_until !== null && moment().isAfter(moment(data.password_valid_until))) {
      store.commit('SET_SHOULD_SHOW_PASSWORD_RENEWAL_WARNING', true)
    }

    data.services = data.services.filter(service => activeServices.includes(service.id))

    return {
      ...data, services: data.services, language: data.language ? data.language.toLowerCase() : null, //  redirect: 'profile'
    }
  },
})

interceptors()

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app', router, store, render: h => h(App), computed: {
    authUser: function () {
      return this.$auth.user()
    }, hasLoaded: function () {
      return this.$store.state.hasLoaded
    }, readyUser: function () {
      return this.$auth.ready()
    }, services: function () {
      return this.$store.state.services
    }, sidebarItems: function () {
      return this.$store.getters.sidebarItems
    },
  }, watch: {
    hasLoaded: function (hasLoaded) {
      if (hasLoaded) {
        let routes = []
        this.sidebarItems.forEach(service => {
          let children = this.createRouteChildren(service)
          let path
          if (service.isMetaService) {
            path = `/${ service.meta }`
          } else {
            path = `/${ service.slug }`
          }
          routes.push({
            name: service.isMetaService ? service.meta : service.slug, path, component: AppLayout, children: children
          })
        })
        this.$router.addRoutes(routes)

        //reset calendar day
        const calendarView = LocalStorageHelper.get(FILTERS_CALENDAR_VIEW)
        if (calendarView === 'timeGridDay') {
          LocalStorageHelper.set(FILTERS_CALENDAR_DAY, moment().format('YYYY-MM-DD'), false)
        } else if (calendarView === 'timeGridWeek') {
          LocalStorageHelper.set(FILTERS_CALENDAR_DAY, moment().startOf('isoWeek').format('YYYY-MM-DD'), false)
        } else if (calendarView === 'dayGridMonth') {
          LocalStorageHelper.set(FILTERS_CALENDAR_DAY, moment().startOf('month').format('YYYY-MM-DD'), false)
        }



        // If user is visiting a route direcly show it if not it should be checked if the user as a default home page set on the DB, if so, redirect ot it, if not, show last visited page from LocalStorage
        if (this.$store.state.redirectFrom && this.$store.state.redirectFrom !== '/') {
          this.$router.push({ path: this.$store.state.redirectFrom })
        } else {
          let lastPage = LocalStorageHelper.get(LocalStorageKeys.LAST_PAGE_ACCESSED)

          if (lastPage && lastPage.uri.includes('/login')) {
            this.$router.push({ path: '/admin/profile' })
          } else if (lastPage && lastPage.email === store.state.loggedUser.email) {
            this.$router.push({ path: lastPage.uri })
          } else if (this.authUser.default_home_page) {
            this.$router.push({ path: this.authUser.default_home_page })
          } else {
            this.$router.push({ path: '/admin/profile' })
          }
        }
        Vue.nextTick(() => {
          this.$store.commit('SET_LOADING', false)
        })
      }
    },
    authUser: function (authUser) {
      if (Object.keys(authUser).length > 0) {
        Vue.i18n.set(authUser.language)

        if (Array.isArray(authUser.services) && authUser.services.length) {
          this.$store.dispatch('INITIALIZE_MODULE', {
            authUser, authToken: LocalStorageHelper.get('default_auth_token', false)
          })

          //console.dir(process.env.VUE_APP_EVOCALL_URL)

          if (authUser.services.some(s => s.url === process.env.VUE_APP_EVOCALL_URL) && process.env.VUE_APP_WEBSOCKETS_ENABLED === 'true') {
            this.$socket.open();
          }
          if (authUser.services.some(s => s.url === process.env.VUE_APP_VIRTUAL_WAITING_ROOM_URL)) {
            //Connect to virtual waiting room socket
            SocketioService.setupSocketConnection(this.$auth.user(), this.$store.state.authToken);
            SocketioService.listenOnlineUsers()
          }

        } else {
          setTimeout(() => {
            SocketioService.disconnect()
            this.$auth.logout({
              redirect: { name: 'login' },
            })
          }, 450)
        }
      }
    },
  }, methods: {
    createRouteChildren(service) {
      let children = []
      service.components.forEach(component => {
        let child = {
          name: `${ service.isMetaService ? service.meta : service.slug }${ component.component }`,
          path: component.component,
          component: lazyLoading(component.component, true),
          props: {
            component, serviceSlug: service.slug
          }
        }

        children.push(child)

        // TODO: Find a way to register these routes in the auth components table
        if (component.component === 'leads') {
          let entityRoute = { ...child }
          entityRoute.name = `${ entityRoute.name }/id`
          entityRoute.path = `${ entityRoute.path }/:id`
          children.push(entityRoute)
        }

        if (component.component === 'entities') {
          let entityRoute = { ...child }
          entityRoute.name = `${ entityRoute.name }/id`
          entityRoute.path = `${ entityRoute.path }/:id`
          entityRoute.component = lazyLoading('entities/EntityDetails')
          children.push(entityRoute)
        }

        if (component.component === 'users') {
          let userRoute = { ...child }
          userRoute.name = `${ userRoute.name }/id`
          userRoute.path = `${ userRoute.path }/:id`
          userRoute.component = lazyLoading('users/UserDetails')
          children.push(userRoute)
        }

        if (component.component === 'evocall/requests') {
          let requestRoute = { ...child }
          requestRoute.name = `${ requestRoute.name }/id`
          requestRoute.path = `${ requestRoute.path }/:id`
          requestRoute.component = lazyLoading('evocall/requests/RequestAnamnesis')
          children.push(requestRoute)
        }

        if (component.component === 'evocall/history') {
          let historyRoute = { ...child }
          historyRoute.name = `${ historyRoute.name }/id`
          historyRoute.path = `${ historyRoute.path }/:id`
          historyRoute.component = lazyLoading('evocall/history/RequestAnamnesisDetails')
          children.push(historyRoute)
        }

        if (component.component === 'licenses/kiosks') {
          let kioskDetailsRoute = { ...child }
          kioskDetailsRoute.name = `${ kioskDetailsRoute.name }/id`
          kioskDetailsRoute.path = `${ kioskDetailsRoute.path }/:id`
          kioskDetailsRoute.component = lazyLoading('licenses/kiosks/Details')
          children.push(kioskDetailsRoute)

          let licenseDetailsRoute = { ...child }
          licenseDetailsRoute.name = `${ licenseDetailsRoute.name.split('/')[0] }/id`
          licenseDetailsRoute.path = `${ licenseDetailsRoute.path.split('/')[0] }/:id`
          licenseDetailsRoute.component = lazyLoading('licenses/Details')
          children.push(licenseDetailsRoute)
        }

        if (component.component === 'homelab/appointments') {
          let homelabAppointmentDetailsRoute = { ...child }
          homelabAppointmentDetailsRoute.name = `${ homelabAppointmentDetailsRoute.name }/id`
          homelabAppointmentDetailsRoute.path = `${ homelabAppointmentDetailsRoute.path }/:id`
          homelabAppointmentDetailsRoute.component = lazyLoading('homelab/appointments/details', true)
          children.push(homelabAppointmentDetailsRoute)
        }

        if (component.component === 'clinical/accounts') {
          let recordDetailsRoute = { ...child }

          recordDetailsRoute.name = `${ recordDetailsRoute.name.split('/')[0] }/accounts/id`
          recordDetailsRoute.path = `${ recordDetailsRoute.path.split('/')[0] }/accounts/:id`
          recordDetailsRoute.component = lazyLoading('clinical/accounts/AccountDetails', true)
          children.push(recordDetailsRoute)
        }

        if (component.component === 'clinical/appointments') {
          let appointmentQuestionnaireRoute = { ...child }

          appointmentQuestionnaireRoute.name = `${ appointmentQuestionnaireRoute.name.split('/')[0] }/appointments/:id/anamnesis/edit`
          appointmentQuestionnaireRoute.path = `${ appointmentQuestionnaireRoute.path.split('/')[0] }/appointments/:id/anamnesis/edit`
          appointmentQuestionnaireRoute.component = lazyLoading('clinical/appointments/AppointmentAnamnesis')

          children.push(appointmentQuestionnaireRoute)
        }

        if (component.component === 'clinical/people') {
          let appointmentQuestionnaireDetailsRoute = { ...child }

          appointmentQuestionnaireDetailsRoute.name = `${ appointmentQuestionnaireDetailsRoute.name.split('/')[0] }/appointments/:id/anamnesis`
          appointmentQuestionnaireDetailsRoute.path = `${ appointmentQuestionnaireDetailsRoute.path.split('/')[0] }/appointments/:id/anamnesis`
          appointmentQuestionnaireDetailsRoute.component = lazyLoading('clinical/appointments/AppointmentAnamnesisDetails')

          children.push(appointmentQuestionnaireDetailsRoute)

          let createPersonRoute = { ...child }

          createPersonRoute.name = `${ createPersonRoute.name.split('/')[0] }/people/create`
          createPersonRoute.path = `${ createPersonRoute.path.split('/')[0] }/people/create`
          createPersonRoute.component = lazyLoading('clinical/people/CreatePerson')

          children.push(createPersonRoute)

          let updatePersonRoute = { ...child }

          updatePersonRoute.name = `${ updatePersonRoute.name.split('/')[0] }/people/:id/edit`
          updatePersonRoute.path = `${ updatePersonRoute.path.split('/')[0] }/people/:id/edit`
          updatePersonRoute.component = lazyLoading('clinical/people/UpdatePerson')

          children.push(updatePersonRoute)

          let personRoute = { ...child }
          personRoute.name = `${ personRoute.name }/id`
          personRoute.path = `${ personRoute.path }/:id`
          personRoute.component = lazyLoading('clinical/people/PersonDetails', true)

          children.push(personRoute)
        }

        if (component.component === 'ranu/records') {
          let recordDetailsRoute = { ...child }
          recordDetailsRoute.name = `${ recordDetailsRoute.name.split('/')[0] }/id`
          recordDetailsRoute.path = `${ recordDetailsRoute.path.split('/')[0] }/:id`
          recordDetailsRoute.component = lazyLoading('ranu/records/Details')
          children.push(recordDetailsRoute)
        }

        if (component.component === 'iframe/project-builder') {
          let iframeRoute = { ...child }
          iframeRoute.name = `${ iframeRoute.name }/id`
          iframeRoute.path = `${ iframeRoute.path }/:id`
          iframeRoute.component = lazyLoading('iframe/project-builder/UpdateProject')
          children.push(iframeRoute)
        }

        if (component.component === 'iframe/media-library') {
          let iframeRoute = { ...child }
          iframeRoute.name = `${ iframeRoute.name }/id`
          iframeRoute.path = `${ iframeRoute.path }/:id`
          iframeRoute.component = lazyLoading('iframe/media-library/UpdateMedia')
          children.push(iframeRoute)
        }

        if (component.component === 'iframe/logo-library') {
          let iframeLogoRoute = { ...child }
          iframeLogoRoute.name = `${ iframeLogoRoute.name }/id`
          iframeLogoRoute.path = `${ iframeLogoRoute.path }/:id`
          iframeLogoRoute.component = lazyLoading('iframe/logo-library/UpdateLogo')
          children.push(iframeLogoRoute)
        }

        if (component.component === 'iframe/blocks-builder') {
          //Info Page
          let infoBlockRoute = { ...child }
          infoBlockRoute.name = `${ infoBlockRoute.name }/info/id`
          infoBlockRoute.path = `${ infoBlockRoute.path }/info/:id`
          infoBlockRoute.component = lazyLoading('iframe/blocks-builder/info/UpdateBlock')
          children.push(infoBlockRoute)

          //Questionnaire Page
          let questionnaireBlockRoute = { ...child }
          questionnaireBlockRoute.name = `${ questionnaireBlockRoute.name }/questionnaire/id`
          questionnaireBlockRoute.path = `${ questionnaireBlockRoute.path }/questionnaire/:id`
          questionnaireBlockRoute.component = lazyLoading('iframe/blocks-builder/questionnaire/UpdateBlock')
          children.push(questionnaireBlockRoute)

          //Thanks Page
          let thanksBlockRoute = { ...child }
          thanksBlockRoute.name = `${ thanksBlockRoute.name }/thanks/id`
          thanksBlockRoute.path = `${ thanksBlockRoute.path }/thanks/:id`
          thanksBlockRoute.component = lazyLoading('iframe/blocks-builder/thanks/UpdateBlock')
          children.push(thanksBlockRoute)

          //Noise Page
          let noiseBlockRoute = { ...child }
          noiseBlockRoute.name = `${ noiseBlockRoute.name }/noise/id`
          noiseBlockRoute.path = `${ noiseBlockRoute.path }/noise/:id`
          noiseBlockRoute.component = lazyLoading('iframe/blocks-builder/noise/UpdateBlock')
          children.push(noiseBlockRoute)

          //Tonal Page
          let tonalBlockRoute = { ...child }
          tonalBlockRoute.name = `${ tonalBlockRoute.name }/tonal/id`
          tonalBlockRoute.path = `${ tonalBlockRoute.path }/tonal/:id`
          tonalBlockRoute.component = lazyLoading('iframe/blocks-builder/tonal/UpdateBlock')
          children.push(tonalBlockRoute)

          //Contact Page
          let contactBlockRoute = { ...child }
          contactBlockRoute.name = `${ contactBlockRoute.name }/contact/id`
          contactBlockRoute.path = `${ contactBlockRoute.path }/contact/:id`
          contactBlockRoute.component = lazyLoading('iframe/blocks-builder/contact/UpdateBlock')
          children.push(contactBlockRoute)

          //User Info Page
          let userInfoBlockRoute = { ...child }
          userInfoBlockRoute.name = `${ userInfoBlockRoute.name }/user-info/id`
          userInfoBlockRoute.path = `${ userInfoBlockRoute.path }/user-info/:id`
          userInfoBlockRoute.component = lazyLoading('iframe/blocks-builder/user-info/UpdateBlock')
          children.push(userInfoBlockRoute)
        }

        if (component.component === 'leads-web/flows') {
          let flowDetailsRoute = { ...child }
          flowDetailsRoute.name = `${ flowDetailsRoute.path}/id`
          flowDetailsRoute.path = `${ flowDetailsRoute.path}/:id`
          flowDetailsRoute.component = lazyLoading('leads-web/flows/UpdateFlow')
          children.push(flowDetailsRoute)
        }

        if (component.component === 'checkup_plus/patients') {
          let oneCarePatientDetailRouter = { ...child }
          oneCarePatientDetailRouter.name = `check-up_plus/checkup_plus/patients/id`
          oneCarePatientDetailRouter.path = `check-up_plus/checkup_plus/patients/:id`
          oneCarePatientDetailRouter.component = lazyLoading('checkup_plus/patients/PatientDetails')

          children.push(oneCarePatientDetailRouter)
        }

        if (component.component === 'people-manager/list') {
          let peopleManagerPatientDetailRouter = { ...child }
          peopleManagerPatientDetailRouter.name = `people_manager/people-manager/list/patient/id`
          peopleManagerPatientDetailRouter.path = `people_manager/people-manager/list/patient/:id`
          peopleManagerPatientDetailRouter.component = lazyLoading('people-manager/patient/PatientDetails')

          children.push(peopleManagerPatientDetailRouter)
        }

      })
      return children
    }
  },
  sockets: {
    connect: function () {
      this.$socket.emit('authenticate', { token: this.$store.state.authToken })
    },
    reconnect: function () {
      console.log('reconnect')
      this.$store.dispatch('RECONNECT')
    },
    reconnection_attempt: function () {
      console.log('reconnection_attempt')
    },
    connect_error: function () {
      console.log('connect_error')
    },
    disconnect: function (reason) {
      console.log('disconnect -> ', reason)
    }
  }
})

window.addEventListener('online', () => {
  if (vm) {
    vm.$store.dispatch('RECONNECT')
  }
})
